<template>
  <div
    class="direct-edit-input-wrapper"
    :style="directEditInput.style"
    v-click-outside="hideEditInputField"
    :class="{ 'range-input': directEditInput.type === 'range' }"
    @wheel.stop
  >
    <div
      :contenteditable="true"
      v-if="directEditInput.type === 'text'"
      class="text-input"
      ref="textInputDiv"
      @blur="setInputValue"
    >
      {{ directEditInput.currentValue }}
    </div>
    <input
      name="edit-input"
      v-model="directEditInput.currentValue"
      ref="input"
      v-else-if="inputTypes.fieldType === 'input'"
      :type="directEditInput.type"
      @keydown="
        (event) =>
          directEditInput?.type === 'number' && preventInputKeyDown(event)
      "
    />
    <div v-else-if="inputTypes.fieldType === 'range'" class="range-wrapper">
      <div class="range-min-max-wrapper">
        <div>{{ getNumberMinMax.min }}</div>
        <div>{{ getNumberMinMax.max }}</div>
      </div>
      <input
        name="edit-input"
        v-model="directEditInput.currentValue"
        ref="input"
        :min="getNumberMinMax.min"
        :max="getNumberMinMax.max"
        type="range"
      />
      <div class="range-value">{{ directEditInput.currentValue }}</div>
    </div>
    <input
      name="edit-input"
      v-model="directEditInput.currentValue"
      ref="input-timestampms"
      v-else-if="inputTypes.fieldType === 'timestampms'"
      type="number"
      @keydown="preventInputKeyDown"
    />
    <textarea
      name="edit-textarea"
      v-model="directEditInput.currentValue"
      ref="textarea"
      v-else-if="inputTypes.fieldType === 'textarea'"
    ></textarea>
    <div
      v-else-if="
        inputTypes.fieldType === 'radio' || inputTypes.fieldType === 'checkbox'
      "
      class="radio-wrapper"
      @wheel.stop
    >
      <div
        v-for="(option, index) in directEditInput.metaData.data.options"
        :key="option.label"
        class="radioOption"
      >
        <input
          :key="directEditInput.metaData.data.label + option.label + Date.now()"
          :id="`option-${index}-input-${directEditInput.metaData.data.id}-`"
          :type="directEditInput.metaData.data.type"
          :value="directEditInput.currentValue"
          :checked="getOptionsValue(option)"
          @change="changeChecked(option)"
        />
        <label
          :for="directEditInput.metaData.data.label + option.label"
          :id="`option-${index}-label-${directEditInput.metaData.data.id}`"
          >{{ option.label }}</label
        >
      </div>
      <span v-if="isCheckboxErrorShow">{{ isCheckboxErrorShow }}</span>
    </div>
    <GeneralDropdown
      className="database-dropdown display-dropdown"
      v-else-if="inputTypes.fieldType === 'select'"
      :name="directEditInput.metaData.data.name"
      :dropdownId="`dropdown-${directEditInput.metaData.data.id}`"
      :class="directEditInput.metaData.data.name"
    >
      <span>{{ directEditInput.metaData.data.label }}</span>
      <template v-slot:selectFilter>
        <span>{{ isSelectedOptionLabel }}</span>
      </template>
      <template v-slot:optionData>
        <b-dropdown-item
          v-for="(option, index) in directEditInput.metaData.data.options"
          :key="option.value"
          @click="changeChecked(option)"
        >
          {{ option.label }}
        </b-dropdown-item>
      </template>
    </GeneralDropdown>
    <NumberComponent
      v-else-if="inputTypes.fieldType === 'formatted_number'"
      :editableComponent="true"
      :decimalValuesCount="
        getFormattedElementToFixedValue(
          directEditInput.metaData.data.name,
          'formatted_number'
        )
      "
      :formatNumber="getFormatNumber(directEditInput.metaData.data.name)"
      :passedNumberValue="directEditInput.currentValue"
      :name="directEditInput.metaData.data.name"
      :maxValue="
        Number(directEditInput.metaData.data.attributes.max) || Infinity
      "
      :minValue="
        Number(directEditInput.metaData.data.attributes.min) || -Infinity
      "
      :elementId="directEditInput.metaData.data.id.toString()"
      @onNumberInputChange="onNumberComponentInputChange"
      ref="number-input"
    />
    <FilePicker
      v-else-if="inputTypes.fieldType === 'filenew'"
      @onFileSelected="onFileSelected"
      :ref="`file-picker-ref`"
      :isAllowedToAddFile="true"
      :isAddOnly="database.add_only"
      :isDownloadButtonVisible="true"
      :value="directEditInput.currentValue"
      :selectedDatabase="database"
      :hideDeleteIcon="true"
    />
  </div>
</template>
<script>
import { getCheckboxMinMax } from '../utils/helpers';
import GeneralDropdown from '../components/core/general-dropdown.vue';
import NumberComponent from '../components/widgets/NumberComponent.vue';
import FilePicker from '../components/core/FilePicker.vue';

export default {
  name: 'DirectEditInput',
  data() {
    return {
      isRadioButtonNotPrefilled: false,
      isCheckboxErrorShow: null,
    };
  },
  props: {
    directEditInput: {
      type: Object,
      required: true,
    },
    getFormattedElementToFixedValue: {
      type: Function,
      required: false,
      default: () => {},
    },
    getFormatNumber: {
      type: Function,
      required: false,
      default: () => {},
    },
    database: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async hideEditInputField() {
      if (
        this.fieldRequiredCheckTypes.includes(this.directEditInput.type) &&
        this.directEditInput.metaData?.data?.attributes?.required &&
        !this.directEditInput.currentValue &&
        this.directEditInput.currentValue !== 0
      ) {
        this.$emit(
          'hideEditInputField',
          this.directEditInput.uuid,
          `Dieses Feld ist erforderlich und Sie müssen einen Wert eingeben`
        );
        return;
      }
      if (this.inputTypes.fieldType === 'checkbox') {
        const totalChecked = this.directEditInput?.currentValue?.length || 0;
        const checkBoxMinMaxValue = getCheckboxMinMax(
          this.directEditInput.metaData.data
        );
        if (totalChecked < checkBoxMinMaxValue.min) {
          this.$emit(
            'hideEditInputField',
            this.directEditInput.uuid,

            `Es dürfen mindestens ${checkBoxMinMaxValue.min}“ Auswahlen ausgewählt werden.`
          );
          return;
        } else if (
          checkBoxMinMaxValue.max !== '' &&
          totalChecked > checkBoxMinMaxValue.max
        ) {
          this.$emit(
            'hideEditInputField',
            this.directEditInput.uuid,

            `Es dürfen maximal ${checkBoxMinMaxValue.max} Auswahlen ausgewählt werden.`
          );
          return;
        }
      } else if (
        this.directEditInput.currentValue &&
        this.directEditInput.type === 'email' &&
        !/^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/.test(
          this.directEditInput.currentValue
        )
      ) {
        this.$emit(
          'hideEditInputField',
          this.directEditInput.uuid,
          `ungültige E-Mail-Adresse`
        );
        return;
      } else if (
        this.directEditInput.type === 'number' ||
        this.directEditInput.type === 'range' ||
        this.directEditInput.type === 'timestampms'
      ) {
        if (
          this.directEditInput.currentValue ||
          this.directEditInput.currentValue === 0
        ) {
          this.directEditInput.currentValue = Number(
            this.directEditInput.currentValue
          );
          if (
            this.directEditInput.type === 'number' &&
            this.getNumberMinMax &&
            (this.directEditInput.currentValue > this.getNumberMinMax.max ||
              this.directEditInput.currentValue < this.getNumberMinMax.min)
          ) {
            this.$emit(
              'hideEditInputField',
              this.directEditInput.uuid,
              `Der Wert sollte nicht größer als ${this.getNumberMinMax.max} und nicht kleiner als ${this.getNumberMinMax.min} sein.`
            );
          }
        } else {
          this.directEditInput.currentValue = null;
        }
      } else if (
        this.directEditInput.type === 'text' &&
        this.directEditInput?.metaData?.data?.attributes?.pattern
      ) {
        const pattern = new RegExp(
          this.directEditInput?.metaData?.data?.attributes?.pattern
        );
        if (pattern) {
          const isValid = pattern?.test(this.directEditInput.currentValue);
          if (!isValid) {
            this.$emit(
              'hideEditInputField',
              this.directEditInput.uuid,
              `Eingabe entspricht nicht dem erwarteten Format. Erlaubtes Muster:${pattern}`
            );
            return;
          }
        }
      }
      this.$emit('hideEditInputField', this.directEditInput.uuid);
    },
    getOptionsValue(option) {
      if (this.directEditInput.type === 'radio') {
        if (this.isRadioButtonNotPrefilled) {
          return false;
        } else if (
          this.directEditInput.currentValue ===
          (option.hasOwnProperty('value') ? option.value : option.label)
        ) {
          return true;
        }
      } else if (this.directEditInput.type === 'checkbox') {
        if (
          this.directEditInput.currentValue &&
          this.directEditInput.currentValue.includes(
            option.hasOwnProperty('value') ? option.value : option.label
          )
        ) {
          return true;
        }
      }
      return false;
    },
    changeChecked(option) {
      if (this.inputTypes.fieldType === 'checkbox') {
        if (!this.directEditInput.currentValue) {
          this.directEditInput.currentValue = [];
        }
        const optionValue = option.hasOwnProperty('value')
          ? option.value
          : option.label;
        if (this.directEditInput.currentValue.includes(optionValue)) {
          const indexToRemove =
            this.directEditInput.currentValue.indexOf(optionValue);
          if (indexToRemove > -1) {
            this.directEditInput.currentValue.splice(indexToRemove, 1);
          }
        } else {
          this.directEditInput.currentValue.push(optionValue);
        }
      } else if (this.inputTypes.fieldType === 'radio') {
        this.isRadioButtonNotPrefilled = false;
        this.directEditInput.currentValue = option.hasOwnProperty('value')
          ? option.value
          : option.label;
      } else if (this.inputTypes.fieldType === 'select') {
        this.directEditInput.currentValue = option.value;
        this.hideEditInputField(this.directEditInput.id);
      }
    },
    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
      });
    },
    onNumberComponentInputChange(newValue) {
      this.directEditInput.currentValue = newValue;
    },
    onFileSelected(file) {
      if (this.$refs[`file-picker-ref`]) {
        this.$refs[`file-picker-ref`].setFile(file);
      }
      this.directEditInput.currentValue = {
        extension: file.name.split('.')[1],
        size: file.size / 1000,
        created: file.lastModified,
        name: file.name,
        link: null,
        modified: file.lastModified,
        readOnly: true,
        type: file.type,
        files: file,
      };
    },
    preventInputKeyDown(e) {
      const selection = window.getSelection();
      if (
        !selection.toString().length &&
        e.target.value?.length >= 38 &&
        /[0-9]/.test(e.key)
      ) {
        e.preventDefault();
      }
    },
    setInputValue() {
      this.directEditInput.currentValue =
        this.$refs.textInputDiv.textContent.trim();
    },
  },
  computed: {
    inputTypes() {
      const textTypes = [
        'email',
        'number',
        'date',
        'datetime-local',
        'text',
        'model',
        'databaseid',
        'hidden',
      ];
      const textAreaTypes = ['textarea', 'smartmessage'];
      return {
        fieldType: textTypes.includes(this.directEditInput.type)
          ? 'input'
          : textAreaTypes.includes(this.directEditInput.type)
          ? 'textarea'
          : this.directEditInput.type,
      };
    },
    isSelectedOptionLabel() {
      if (
        this.directEditInput.currentValue != null &&
        this.directEditInput.currentValue != ''
      ) {
        return this.directEditInput.metaData.data.options.find(
          (option) => option.value === this.directEditInput.currentValue
        ).label;
      } else return 'wähle eine Option';
    },
    fieldRequiredCheckTypes() {
      return [
        'text',
        'email',
        'number',
        'date',
        'datetime-local',
        'model',
        'databaseid',
        'textarea',
        'smartmessage',
        'formatted_number',
        'select',
        'timestampms',
      ];
    },
    getNumberMinMax() {
      const attributes = this.directEditInput?.metaData?.data?.attributes;
      if (
        (attributes?.min || attributes?.min === 0) &&
        (attributes?.max || attributes?.max === 0)
      ) {
        return {
          min: attributes.min,
          max: attributes?.max,
        };
      }
      return undefined;
    },
  },
  mounted() {
    if (this.directEditInput.type === 'text') {
      setTimeout(() => {
        const el = this.$refs.textInputDiv;
        el.focus();
        const range = document.createRange();
        const selection = window.getSelection();
        range.selectNodeContents(el);
        range.collapse(false);
        selection.removeAllRanges();
        selection.addRange(range);
      });
    } else if (
      this.directEditInput.metaData.data?.attributes?.prefilled === false &&
      this.directEditInput.currentValue === null
    ) {
      this.isRadioButtonNotPrefilled = true;
    }
  },
  components: {
    GeneralDropdown,
    NumberComponent,
    FilePicker,
  },
};
</script>
<style scoped>
.direct-edit-input-wrapper {
  position: fixed;
  z-index: 100;
  border-radius: 6px;
  background: white;
  backdrop-filter: none;
  box-shadow: rgba(15, 15, 15, 0.05) 0px 0px 0px 1px,
    rgba(15, 15, 15, 0.1) 0px 3px 6px, rgba(15, 15, 15, 0.2) 0px 9px 24px;
}

.direct-edit-input-wrapper input {
  margin: 0 0 0;
  min-width: 250px;
  width: auto;
  margin: 10px 12px;
  height: auto;
  color: #464d5d;
  font-size: 13px;
  font-weight: 400;
  line-height: 19px;
  -webkit-box-shadow: none;
}

.direct-edit-input-wrapper .edit-input {
  min-height: 40px;
}
.direct-edit-input-wrapper ::v-deep .file-selected {
  min-width: 150px;
  box-shadow: none;
}

.direct-edit-input-wrapper ::v-deep .number-input,
.direct-edit-input-wrapper ::v-deep .dropped-file-name {
  border-radius: 6px;
}
.direct-edit-input-wrapper input:focus-visible,
.direct-edit-input-wrapper ::v-deep .number-input:focus-visible {
  outline: none;
}
.direct-edit-input-wrapper textarea {
  resize: none;
  background: #fff;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  padding: 12px;
  min-height: 140px;
}
.direct-edit-input-wrapper .radio-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  gap: 10px;
  max-height: 411px;
  max-width: 322px;
}
.direct-edit-input-wrapper .radioOption {
  display: inline-flex;
  height: auto;
  align-items: center;
  gap: 10px;
}

.direct-edit-input-wrapper .radioOption label {
  line-height: 21px;
  padding: 0;
  margin-bottom: 0;
  margin-right: 0;
  width: auto;
}

.direct-edit-input-wrapper .radioOption input {
  float: none;
  width: 15px;
  margin-bottom: 0;
  height: 15px;
  min-width: unset;
  margin: 0;
  padding: 8px 10px;
}
.direct-edit-input-wrapper .database-dropdown ::v-deep .customDropdown {
  width: 100% !important;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  height: 37px;
  color: #464d5d;
  justify-content: space-between;
  padding: 0px 15px 0px 15px;
}
.direct-edit-input-wrapper ::v-deep .database-dropdown {
  width: 100%;
  background: #fff;
}
.direct-edit-input-wrapper ::v-deep .database-dropdown .dropdown-menu {
  width: 100%;
}
.direct-edit-input-wrapper ::v-deep .database-dropdown.display-dropdown {
  width: 100%;
  position: relative;
  z-index: 100 !important;
}
.direct-edit-input-wrapper .range-min-max-wrapper {
  display: flex;
  justify-content: space-between;
  padding: 7px 12px 0 12px;
  color: #464d5d;
  font-size: 13px;
  font-weight: 400;
}
.direct-edit-input-wrapper .range-wrapper input {
  margin: 5px 12px;
}
.direct-edit-input-wrapper .range-value {
  display: flex;
  justify-content: center;
  font-size: 13px;
  font-weight: bold;
}
.direct-edit-input-wrapper .text-input {
  margin: 10px 12px;
  width: 230px;
  word-break: break-all;
  outline: none;
}
</style>
